import * as XLSX from 'xlsx';

export interface CellData {
  id: string; // Unique ID (e.g., "Sheet1!A1")
  value: string;
}

export const parseExcelFile = async (file: File): Promise<CellData[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = e.target?.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const allCells: CellData[] = [];

        workbook.SheetNames.forEach((sheetName) => {
          const sheet = workbook.Sheets[sheetName];
          // Use !ref to get the range, but we can also just iterate keys
          const range = XLSX.utils.decode_range(sheet['!ref'] || 'A1');
          
          for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
              const cellAddress = { c: C, r: R };
              const cellRef = XLSX.utils.encode_cell(cellAddress);
              const cell = sheet[cellRef];

              if (cell && cell.v !== undefined && cell.v !== null && String(cell.v).trim() !== '') {
                 // Format the value to string
                 let cellValue = String(cell.v);
                 if(cell.w) cellValue = cell.w; // Use formatted text if available

                 allCells.push({
                   id: `${sheetName}!${cellRef}`,
                   value: cellValue
                 });
              }
            }
          }
        });

        resolve(allCells);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => reject(error);
    reader.readAsBinaryString(file);
  });
};
